module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "PainterList"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('el-card', {
    attrs: {
      "id": "list"
    }
  }, [_c('div', {
    staticClass: "patientList-operate"
  }, [_c('button', {
    attrs: {
      "id": "danger"
    },
    on: {
      "click": _vm.deleteP
    }
  }, [_vm._v(_vm._s(_vm.$t('Delete')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.findPatient
    }
  }, [_vm._v(_vm._s(_vm.$t('findP')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.NewPatient
    }
  }, [_vm._v(_vm._s(_vm.$t('newP')))]), _vm._v(" "), _c('el-popover', {
    ref: "popover1",
    attrs: {
      "placement": "bottom-start",
      "width": "300",
      "trigger": "hover",
      "disabled": _vm.tooltipVisible
    }
  }, [_c('div', {
    staticClass: "patientList-label-tooltip"
  }, [_c('div', {
    staticClass: "patientList-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Filter')))])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small2-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "label-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab2),
      expression: "lab2"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab2, 'de6': _vm.isDe || _vm.isIt, 'po4': _vm.isPo, 'fr2': _vm.isFr
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Female')))]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab3),
      expression: "lab3"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab3, 'es3': _vm.isEs, 'de6': _vm.isDe || _vm.isIt, 'po4': _vm.isPo
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Male')))]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab17),
      expression: "lab17"
    }],
    staticClass: "filter-label",
    class: {
      'choose4': _vm.lab17, 'de17': _vm.isDe, 'po17': _vm.isPo || _vm.isDu
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('genUn')))]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab18),
      expression: "lab18"
    }],
    staticClass: "filter-label",
    class: {
      'choose4': _vm.lab18, 'po19': _vm.isPo || _vm.isDu
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('ageUn')))]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab6),
      expression: "lab6"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab6
    }
  }, [_c('span', [_vm._v("< 18")]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab7),
      expression: "lab7"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab7
    }
  }, [_c('span', [_vm._v("18-40")]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab8),
      expression: "lab8"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab8
    }
  }, [_c('span', [_vm._v("40-60")]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab9),
      expression: "lab9"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab9
    }
  }, [_c('span', [_vm._v("> 60")]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab19),
      expression: "lab19"
    }],
    staticClass: "filter-label",
    class: {
      'choose4': _vm.lab19, 'de18': _vm.isDe || _vm.isFr, 'it18': _vm.isIt, 'es18': _vm.isEs, 'po18': _vm.isPo || _vm.isDu, 'sw2': _vm.isSw
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('disUn')))]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab16),
      expression: "lab16"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab16
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Other')))]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab11),
      expression: "lab11"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab11, 'cz2': _vm.isCz
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Type 1')))]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab12),
      expression: "lab12"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab12, 'cz2': _vm.isCz
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Type 2')))]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab13),
      expression: "lab13"
    }],
    staticClass: "filter-label",
    class: {
      'choose2': _vm.lab13, 'de2': _vm.isDe, 'it6': _vm.isIt, 'du4': _vm.isDu, 'fr1': _vm.isFr, 'cz3': _vm.isCz
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Gestational')))]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab14),
      expression: "lab14"
    }],
    staticClass: "filter-label",
    class: {
      'choose2': _vm.lab14, 'po5': _vm.isPo
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Prediabetes')))]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab15),
      expression: "lab15"
    }],
    staticClass: "filter-label",
    class: {
      'choose3': _vm.lab15, 'ZH2': _vm.styleChange
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('LADA')))]), _c('img', {
    attrs: {
      "src": require("../assets/cancel_black.png")
    }
  })])])])]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover1",
      arg: "popover1"
    }],
    attrs: {
      "id": "filter",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Filter')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hcpGroupMenu),
      expression: "hcpGroupMenu"
    }],
    staticClass: "back-btn",
    on: {
      "click": function($event) {
        _vm.backToMenu()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v(_vm._s(_vm.$t('t0805_Back')))])]), _vm._v(" "), _c('div', {
    staticClass: "patientList-search",
    class: {
      'patientList-in': _vm.searchPatient
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "focus": function($event) {
        _vm.check(0)
      },
      "blur": function($event) {
        _vm.check(1)
      },
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.check(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    class: {
      'patientList-in1': _vm.searchPatient
    },
    attrs: {
      "src": require("../assets/search.png")
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "patient-table"
  }, [_c('table', {
    attrs: {
      "id": "patientList"
    }
  }, [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticClass: "checkbox22",
    attrs: {
      "type": "checkbox",
      "id": "checkbox1"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Gender')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Age')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Type')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Duration')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Connections')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('UploadTime')))])]), _vm._v(" "), _vm._l((_vm.currentPageData), function(item, index) {
    return (!_vm.displayTab) ? _c('tr', {
      key: index,
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "data": _vm.users
      }
    }, [_c('td', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkList),
        expression: "checkList"
      }],
      staticClass: "checkbox22",
      attrs: {
        "type": "checkbox",
        "autocomplate": "off"
      },
      domProps: {
        "value": item.uid,
        "checked": Array.isArray(_vm.checkList) ? _vm._i(_vm.checkList, item.uid) > -1 : (_vm.checkList)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.checkList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.uid,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.checkList = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.checkList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkList = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "name",
      attrs: {
        "id": index
      },
      on: {
        "click": _vm.goDetail
      }
    }, [_c('img', {
      ref: "imgs",
      refInFor: true,
      staticClass: "portrait",
      attrs: {
        "src": _vm.imgSrc,
        "onload": _vm.imgload(item.uid)
      }
    }), _vm._v(" "), _c('p', {
      class: {
        'filterResult': _vm.filFlag2
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', {
      staticClass: "gender"
    }, [_vm._v(_vm._s(item.gender))]), _vm._v(" "), _c('td', {
      staticClass: "small"
    }, [_vm._v(_vm._s(item.age))]), _vm._v(" "), _c('td', {
      staticClass: "small"
    }, [_vm._v(_vm._s(item.diabetes_type))]), _vm._v(" "), _c('td', {
      staticClass: "diabetes-date"
    }, [_vm._v(_vm._s(item.diabetes_diagnosis_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_by))]), _c('td', [_vm._v(_vm._s(item.upload_time))])]) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.displayTab) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "empty-text": "--",
      "element-loading-text": _vm.$t('Loading'),
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "patientList-block"
  }, [_c('img', {
    class: {
      'click1': _vm.currentPage == 1
    },
    attrs: {
      "src": require("../assets/arrow_right.png")
    },
    on: {
      "click": _vm.prevPage
    }
  }), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage),
      expression: "currentPage"
    }],
    domProps: {
      "value": (_vm.currentPage)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.go($event)
      },
      "blur": _vm.go,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPage = $event.target.value
      }
    }
  }), _vm._v(" of   " + _vm._s(_vm.totalPage))]), _vm._v(" "), _c('img', {
    class: {
      'click1': _vm.currentPage == _vm.totalPage
    },
    attrs: {
      "src": require("../assets/arrow_left.png")
    },
    on: {
      "click": _vm.nextPage
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogFormVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Filter')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/cancel.png")
    },
    on: {
      "click": _vm.cancelFilter
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "lab-group1"
  }, [_c('label', {
    class: {
      'de3': _vm.isDe || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Gender')))]), _vm._v(" "), _c('div', {
    staticClass: "patientList-line",
    class: {
      'de4': _vm.isDe
    }
  }, [_c('div', {
    staticClass: "label1",
    class: {
      'choose': _vm.lab1, 'ZH1': _vm.styleChange, 'es2': _vm.isEs || _vm.isIt || _vm.isFr, 'de5': _vm.isDe, 'po2': _vm.isPo, 'du2': _vm.isDu, 'pl2': _vm.isPl
    },
    on: {
      "click": _vm.choose1
    }
  }, [_c('span', {
    class: {
      'ZH': _vm.styleChange || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('All')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab1),
      expression: "lab1"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose2': _vm.lab17, 'es1': _vm.isEs, 'de1': _vm.isDe, 'po3': _vm.isPo, 'du3': _vm.isDu, 'fr1': _vm.isFr, 'sw1': _vm.isSw, 'pl3': _vm.isPl
    },
    on: {
      "click": function($event) {
        _vm.choose17()
      }
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab17),
      expression: "lab17"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab2, 'de6': _vm.isDe || _vm.isIt, 'po4': _vm.isPo, 'fr2': _vm.isFr
    },
    on: {
      "click": _vm.choose2
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Female')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab2),
      expression: "lab2"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab3, 'es3': _vm.isEs, 'de6': _vm.isDe || _vm.isIt, 'po4': _vm.isPo, 'pl4': _vm.isPl
    },
    on: {
      "click": _vm.choose3
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Male')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab3),
      expression: "lab3"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "lab-group2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Age')))]), _vm._v(" "), _c('div', {
    staticClass: "patientList-line"
  }, [_c('div', {
    staticClass: "label1",
    class: {
      'choose': _vm.lab5, 'ZH1': _vm.styleChange, 'es2': _vm.isEs || _vm.isIt || _vm.isFr, 'de5': _vm.isDe, 'po2': _vm.isPo, 'du2': _vm.isDu, 'pl2': _vm.isPl
    },
    on: {
      "click": _vm.choose5
    }
  }, [_c('span', {
    class: {
      'ZH': _vm.styleChange || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('All')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab5),
      expression: "lab5"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose2': _vm.lab18, 'es1': _vm.isEs, 'de1': _vm.isDe, 'po3': _vm.isPo, 'du3': _vm.isDu, 'fr1': _vm.isFr, 'sw1': _vm.isSw, 'pl3': _vm.isPl
    },
    on: {
      "click": function($event) {
        _vm.choose18()
      }
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab18),
      expression: "lab18"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab6
    },
    on: {
      "click": _vm.choose6
    }
  }, [_c('span', [_vm._v(" < 18")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab6),
      expression: "lab6"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab7
    },
    on: {
      "click": _vm.choose7
    }
  }, [_c('span', [_vm._v("18-40")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab7),
      expression: "lab7"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab8, 'ZH8': _vm.styleChange
    },
    on: {
      "click": _vm.choose8
    }
  }, [_c('span', [_vm._v("41-60")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab8),
      expression: "lab8"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label small_lab",
    class: {
      'choose1': _vm.lab9, 'ZH9': _vm.styleChange
    },
    on: {
      "click": _vm.choose9
    }
  }, [_c('span', [_vm._v("> 60")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab9),
      expression: "lab9"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "lab-group3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Type')))]), _vm._v(" "), _c('div', {
    staticClass: "patientList-line"
  }, [_c('div', {
    staticClass: "label1",
    class: {
      'choose': _vm.lab10, 'ZH1': _vm.styleChange, 'es2': _vm.isEs || _vm.isIt || _vm.isFr, 'de5': _vm.isDe, 'po2': _vm.isPo, 'du2': _vm.isDu, 'pl2': _vm.isPl
    },
    on: {
      "click": _vm.choose10
    }
  }, [_c('span', {
    class: {
      'ZH': _vm.styleChange || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('All')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab10),
      expression: "lab10"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "patientList-type"
  }, [_c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose3': _vm.lab19, 'ZH5': _vm.styleChange, 'es1': _vm.isEs, 'de1': _vm.isDe, 'po3': _vm.isPo, 'du3': _vm.isDu, 'fr1': _vm.isFr, 'sw1': _vm.isSw, 'cz1': _vm.isCz, 'pl3': _vm.isPl
    },
    on: {
      "click": _vm.choose19
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab19),
      expression: "lab19"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab11, 'cz2': _vm.isCz
    },
    on: {
      "click": _vm.choose11
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Type 1')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab11),
      expression: "lab11"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab12, 'cz2': _vm.isCz
    },
    on: {
      "click": _vm.choose12
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Type 2')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab12),
      expression: "lab12"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab1",
    class: {
      'choose3': _vm.lab15, 'ZH2': _vm.styleChange
    },
    on: {
      "click": _vm.choose15
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('LADA')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab15),
      expression: "lab15"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose2': _vm.lab13, 'de2': _vm.isDe, 'it6': _vm.isIt, 'du4': _vm.isDu, 'fr1': _vm.isFr, 'ZH10': _vm.styleChange, 'cz3': _vm.isCz
    },
    on: {
      "click": _vm.choose13
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Gestational')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab13),
      expression: "lab13"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose2': _vm.lab14, 'po5': _vm.isPo, 'pl1': _vm.isPl
    },
    on: {
      "click": _vm.choose14
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Prediabetes')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab14),
      expression: "lab14"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label small_lab",
    class: {
      'choose1': _vm.lab16
    },
    on: {
      "click": _vm.choose16
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('OTR1')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab16),
      expression: "lab16"
    }],
    attrs: {
      "src": require("../assets/cancel_red.png")
    }
  })])])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr patientList-spe1-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "patientList-dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.checkFilter
    }
  }, [_vm._v(_vm._s(_vm.$t('Apply')))])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showConfirmDialog,
      "size": _vm.dialogSize2,
      "id": "dialog-form3",
      "show-close": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showConfirmDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('privacy_policy_and_terms_of_use')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('privacy_confirm_text'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('button', {
    staticClass: "deny",
    on: {
      "click": _vm.denyPrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy_confirm_disagree')))]), _vm._v(" "), _c('button', {
    staticClass: "agree",
    on: {
      "click": _vm.agreePrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy_confirm_accept')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4964cdfa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PatientList.vue
// module id = 1461
// module chunks = 7